import request from '@/utils/request'

// 商户分页（按当前登录员工）
export const getStorePageByEmp = (params: any) => {
  return request({
    url: '/store/pageByEmpId',
    method: 'get',
    params
  })
}

// 新增商户
export const addStore = (data: any) => {
  return request({
    url: '/store',
    method: 'post',
    data: { ...data }
  })
}

// 修改商户
export const updateStore = (data: any) => {
  return request({
    url: '/store',
    method: 'put',
    data: { ...data }
  })
}

// 删除商户
export const deleteStore = (id: string | number) => {
  return request({
    url: '/store',
    method: 'delete',
    params: { id }
  })
}

/** 驳回/未申请后重新提交入驻审核 */
export const submitStoreAudit = (id: string | number) => {
  return request({
    url: `/store/submitAudit/${id}`,
    method: 'post'
  })
}

/** 入驻审核通过后申请首次启用 */
export const applyEnableStore = (id: string | number) => {
  return request({
    url: `/store/applyEnable/${id}`,
    method: 'post'
  })
}

/** 审核入驻：auditStatus 1通过 2驳回 */
export const auditStore = (data: {
  id: string | number
  auditStatus: number
  auditRemark?: string
}) => {
  return request({
    url: '/store/audit',
    method: 'post',
    data
  })
}

/** 审核启用申请：auditStatus 1通过 2驳回 */
export const auditEnableStore = (data: {
  id: string | number
  auditStatus: number
  auditRemark?: string
}) => {
  return request({
    url: '/store/auditEnable',
    method: 'post',
    data
  })
}

// 查询商户详情
export const getStoreInfo = (id: string | number) => {
  return request({
    url: '/store/info',
    method: 'get',
    params: { id }
  })
}

// 查询当前员工下的所有商户（不分页，可用于下拉选择）
export const listMyStores = () => {
  return request({
    url: '/store/listByEmp',
    method: 'get'
  })
}
